export default {
  init() {
      //Wrap <span> for button link
      $('.main-menu .max-mega-menu .menu-item-button > a.mega-menu-link').wrapInner( '<span></span>' );

       // Toggle Search Menu
      $('.mega-menu').on('after_mega_menu_init', function() {
        $('.main-menu .max-mega-menu .menu-item-search-toggle > a.mega-menu-link').on('click', function(e) {
          e.preventDefault();
          $(this).toggleClass('open');
          $('.nav-search-form').slideToggle(250);
          $('.max-mega-menu').data('maxmegamenu').hideAllPanels();
        });
      });

      // Move Seach form and Top quick links for mobile or desktop
      $(window).on('resize', function() {
        if ($(window).width() <= 1200) {
          $('#siteHeader #navSearchForm').appendTo('#siteHeader .menu-item-search-toggle');
          $('#siteHeader #navSearchForm').show();
          $('#siteHeader #top-quick-links').prependTo('#siteHeader .menu-item-logo');
        } else {
          $('#siteHeader #navSearchForm').appendTo('#siteHeader #main-menu');
          $('#siteHeader #navSearchForm').hide();
          $('#siteHeader #top-quick-links').prependTo('#siteHeader > .container');
        }
      }).trigger('resize');

      // Video modal controls
      $('.video-modal').on('show.bs.modal', function (e) {

          const t = $(e.relatedTarget);
          const url = t.attr('data-video').replace('autoplay=0', 'autoplay=1');
          const labeler = t.prop('id');
          $(e.target).prop('aria-labelledby', labeler);
          $(e.target).find('iframe').prop('src', url);

      }).on('hide.bs.modal', function (e) {

          const t = $(e.target);
          const url = t.find('iframe').first().prop('src');
          t.find('iframe').prop('src', url.replace('autoplay=1', 'autoplay=0'));

      });

      $('form.auto-submit input, form.auto-submit select, form.auto-submit textarea').on('change', function (e) {
          $(e.target).parents('form').first().submit();
      });

      $('.page-header-background video').each(function(i,el){
        $(el).on('canplaythrough', function(e) {
          let $target = $(e.target);
          $target.fadeIn(800);
        });
        setTimeout(function(){ el.pause(); }, 3600*1000);
      });

      $('#footerMain .footer-address a').attr('target','_blank');

      // Open request an appointment links in new window
      $('a.provider-appt-link, a.location-appt-link, a.specialty-appt-link, a.context-appt-link, a.target-blank').attr('target','_blank');

      // Accordion
      $('.accordion .accordion-trigger').on('click',function(e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.parent().next().hasClass('active')) {
          $this.parent().next().slideUp('slow', function() {
            $this.removeClass('active');
            $this.parent().next().removeClass('active');
            $this.parent().next().attr('hidden', '');
            $this.attr('aria-expanded', 'false');
          });
        } else {
          $this.parent().next().removeAttr('hidden');
          $this.attr('aria-expanded', 'true');
          $this.toggleClass('active');
          $this.parent().next().toggleClass('active');
          $this.parent().next().slideToggle('active');
        }
      });

      // Ajax call
      /*
      $('#providerFilterAcceptingNew').on('change', function(e) {
        e.preventDefault();
        let acceptingNew = $(this).val();
        $.ajax({
          type: 'post',
          dataType : 'json',
          url: `${window.location.origin}/wp-admin/admin-ajax.php`,
          data: {
            action: 'provider_filter_listings',  // the action to fire in the server
            data: {
              acceptingNew: acceptingNew,
            },
          },
          complete: function (response) {
            //console.log(JSON.parse(response.responseText).data);
            console.log(response);
          },
        });
      });
      */

      // A-Z Filter (/specialties-services/)
      const $postsResultsItems = $('#posts-results > a');
      const $filterItemsActive = $('#a-z-filter li.active');
      const $specialtySearchForm = $('#specialty-search-form');
      const $specialtySearchFormInput = $('#specialty-search-form-input');

      let clickedFirstChar = '';

      const resetAZFilter = function() {
        clickedFirstChar = '';
        $filterItemsActive.removeClass('current');
        $postsResultsItems.show();
      };

      $filterItemsActive.on('click', function() {
        $postsResultsItems.hide();
        $filterItemsActive.removeClass('current');
        $specialtySearchFormInput.val(null);

        if (clickedFirstChar !== $(this).data('letter')) {
          clickedFirstChar = $(this).data('letter');
          $(this).addClass('current');
          $('#posts-results a[data-letter="' + clickedFirstChar + '"]').show();
        } else {
          clickedFirstChar = '';
          $postsResultsItems.show();
        }
      });

      $specialtySearchForm.submit(function(event){
        event.preventDefault();
      });

      $specialtySearchFormInput.on('keyup', function(){
        let inputValue = $(this).val().toLowerCase().trim();
        let v = inputValue.split('%');

        resetAZFilter();

        $postsResultsItems.each(function(index, el) {
          let itemText = $(el).data('title');

          $.each(v, function(i, inputVal) {
            if (itemText.indexOf(inputVal) > -1) {
              $(el).show();
            } else {
              $(el).hide();
            }
          });
        });
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Add fallback image if featured image is not set for Divi Blog Module
    if ($('.et_pb_posts').length) {
      $('.et_pb_posts .et_pb_post').each(function () {
        const post = $(this);

        // Skip if already has image or fallback
        if (
          post.find('.entry-featured-image-url').length === 0 &&
          post.find('.fallback-image').length === 0
        ) {
          const fallbackImageUrl = '/wp-content/themes/MCSage/dist/images/logo-mankato-clinic.svg';
          const postLink = post.find('h2.entry-title a').attr('href') || '#';
          const postTitle = post.find('h2.entry-title a').text() || 'Post';

          const fallbackImage = $('<a>', {
            class: 'entry-featured-image-url fallback-image',
            href: postLink,
          }).append(
            $('<img>', {
              src: fallbackImageUrl,
              alt: postTitle,
              class: 'wp-post-image',
            })
          );

          post.find('h2.entry-title').first().before(fallbackImage);
        }
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js